module.exports = __webpack_public_path__ + "img/stretch--genre1-img1--sp.de41ab78.jpg";